import React from 'react'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.bundle"
import './css/article.css'

export default function ExploreMore() {
  return (

    <>
    <div className='header-containerr'>
    <header className='header-name'>
        <h1>YouMayLike</h1>
    </header>
    </div>
<div className="wrapper">
 
  <div className="article-grid">
    <div className="article-item">
      <div className="image-box">
        <a href="#">
        <img src="./bmw-m4-csl-mi-05.jpg" alt="News Image 1" />
        </a>
      </div>
      <a href="#" className='anchor'>
      <h2 id='dd'>
        Could This Smart Shopping Cart Be the Solution to Self-Checkout
        Headaches?
      </h2>
      <p>
        The smart shopping cart has substantially enhanced the shopping
        experience.
      </p>
      </a>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <a href="#">Read More »</a>
    </div>
    <div className="article-item">
      <div className="image-box">
        <a href="#">
        <img src="" alt="News Image 2" />
        </a>
      </div>
      <a href="#" className='anchor'>
      <h2>Cyborg Insects Set to Revolutionise Robotics Industry</h2>
      <p>
        Scientific achievement, researchers have successfully developed a method
        to mass-produce.
      </p>
      </a>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <a href="#">Read More »</a>
    </div>
    <div className="article-item">
      <div className="image-box">
        <a href="#">
        <img src="./images/COVER.png" alt="News Image 3" />
        </a>
      </div>
      <a href="#" className='anchor'>
      <h2>TikTok Nears Potential US Ban: Key Details You Need to Know</h2>
      <p>TikTok’s troubling troubles have been in the spotlight.</p>
      </a>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <a href="#">Read More »</a>
    </div>
    
    
    
   
  </div>
</div>
</>
  )
}
